import {
  Button,
  // Container,
  // Paper,
  // Typography,
  Grid,
} from "@mui/material";
import React, { useEffect } from "react";

import { useUser } from "../globals/UserContext.js";
import { useClass } from "../globals/ClassContext.js";
import Assignment from "../components/Assignments/Assignment";
import DeletionModal from "../components/Modals/DeletionModal/DeletionModal.js";
import ClassNav from "../components/Buttons/ClassNav.js";
import NewAssignmentModal from "../components/Assignments/NewAssignmentModal.js";

export default function Assignments(props) {
  const user = useUser();
  const classroom = useClass();

  const { setPage } = props

  const [confirmationModalOpen, setConfirmationModalOpen] = React.useState(false);
  const handleConfirmationOpen = () => setConfirmationModalOpen(true);
  const handleConfirmationClose = () => setConfirmationModalOpen(false);

  const [confirmationEffect, setConfirmationEffect] = React.useState(() => console.log("No confirmation effect."));
  
  const [confirmationText, setConfirmationText] = React.useState("");  


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  useEffect(() => {

  }, [user, classroom])


  return (
    <Grid
    container
    spacing={2}
    direction="column"
    maxWidth="70rem"
    margin="auto"
    sx={{ paddingTop: "80px" }}>
      <ClassNav />
      <Button 
        variant="contained"
        color="gray"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{margin: "15px", maxWidth:"225px"}}
        onClick={handleOpen}
      >
        {Object.keys(classroom).length === 0 ? "Create an assignment" : "Add an assignment"}
      </Button>
      {Object.keys(classroom).length !== 0 ? (
        classroom?.assignments?.map( (assignment) => <Assignment setPage={setPage} key={(typeof assignment === "string") ? assignment : assignment._id} assignmentID={(typeof assignment === "string") ? assignment : assignment._id} classID={classroom._id} handleConfirmationOpen={handleConfirmationOpen} setConfirmationEffect={setConfirmationEffect} setConfirmationText={setConfirmationText}></Assignment>)
      ) : (
        user?.assignments?.map( (assignment) => <Assignment setPage={setPage} key={(typeof assignment === "string") ? assignment : assignment._id} assignmentID={(typeof assignment === "string") ? assignment : assignment._id} classID={classroom._id} handleConfirmationOpen={handleConfirmationOpen} setConfirmationEffect={setConfirmationEffect} setConfirmationText={setConfirmationText}></Assignment>)
      )}
      <NewAssignmentModal
        forUser={Object.keys(classroom).length === 0}
        setPage={setPage}
        open={open}
        setOpen={setOpen}
        handleClose={handleClose}
        user={user}
        classroom={classroom}
      ></NewAssignmentModal>
      <DeletionModal open={confirmationModalOpen} notification={confirmationText} onSubmit={confirmationEffect} handleClose={handleConfirmationClose}></DeletionModal>
    </Grid>
  ) 
}
